<template>
    <div class="orgDetail">
        <div class="left-box">
            <LeftPage :active="1"/>
        </div>
        <div class="right-box flex flex-direction">
            <div class="table-box flex-sub">
                <div class="title">
                    <div class="icon-box">
                        <i class="iconfont icon-zhanghao1"></i>
                    </div>
                    <b>账号管理</b>
                </div>
                <div class="search-flex">
                    <div class="search-box">
                        <el-form ref="form" :model="search" class="flex" label-width="80px">
                            <el-form-item label="关键词">
                                <el-input v-model="search.keyword" placeholder="请输入关键词"></el-input>
                            </el-form-item>
                        </el-form>
                        <div class="search-btn" @click="refreshList">
                            <i class="iconfont icon-sousuo"></i>搜索
                        </div>
                        <div class="shensu margin-left-sm" @click="addItem(false)">
                            <i class="el-icon-plus"></i>添加子帐号
                        </div>
                    </div>

                </div>
                <div class="list ">
                    <el-table
                        :cell-style="textCenter"
                        :data="tableData"
                        :header-cell-style="centerbgc"
                        v-loading="loading"
                        border
                        style="width: 100%">
                        <el-table-column
                            label="序号"
                            type="index"
                            width="80">
                        </el-table-column>
                        <el-table-column
                            label="账号名称"
                            prop="username"
                            width="">
                        </el-table-column>
                        <el-table-column
                            label="添加时间"
                            prop="create_time"
                            width="">
                        </el-table-column>
<!--                        <el-table-column-->
<!--                            label="备注说明"-->
<!--                            prop="is_lock"-->
<!--                            width="">-->
<!--                        </el-table-column>-->
                        <el-table-column
                            label="操作"
                            width="180">
                            <template slot-scope="scope" class="flex">
                                <el-link type="primary" @click="addItem(scope.row)">编辑</el-link>
                                <el-link class="margin-left-sm" type="danger">删除</el-link>
                            </template>
                        </el-table-column>
                    </el-table>
                </div>

                <div class="page-box">
                    <el-pagination
                        :current-page.sync="search.page"
                        :page-size="search.limit"
                        :total="search.total"
                        background
                        class="page-all margin-top self-end"
                        layout="prev, pager, next"
                        @current-change="list">
                    </el-pagination>
                </div>
            </div>
        </div>
        <add-account-dialog :id="cur_id" :dialog-visible="addAccountDialog"
                            :username="cur_name" @handleClose="handleClose"></add-account-dialog>
    </div>
</template>
<script>
import {delAccount, getAccountList} from "@/api/admin";
import LeftPage from "@/views/admin/pages/role/common/leftPage";
import {confirm} from "@/utils/utils";
import AddAccountDialog from "@/views/admin/pages/role/common/addAccountDialog";

export default {
    name: "account",
    data() {
        return {
            search: {
                keyword: '',
                page: 1,
                limit: 10,
                total: 0,
            },
            tableData: [],

            cur_id: '',
            cur_name: '',
            addAccountDialog: false,
            loading: false
        }
    },
    components: {AddAccountDialog, LeftPage},
    computed: {
        textCenter() {
            return {
                textAlign: 'center'
            }
        },
        centerbgc() {
            return {
                textAlign: 'center',
                background: '#f7f7f7'
            }
        }
    },
    created() {
        this.$emit("setActive", {
            headActive: 6
        })
        this.list()
    },
    methods: {
        async list() {
            this.loading = true
            let _data = await getAccountList(
                this.search.keyword,
                this.search.page,
                this.search.limit
            );
            this.loading = false
            if (_data.status == 200) {
                this.tableData = _data.data.data
                this.search.total = _data.data.total
            } else {
                this.$message.error(_data.msg)
            }
        },
        refreshList() {
            this.search.page = 1
            this.list()
        },
        addItem(item) {
            this.cur_id = item ? item.id : ''
            this.cur_name = item ? item.username : ''
            this.addAccountDialog = true
        },
        handleClose(data) {
            if (data) this.list()
            this.addAccountDialog = false
        },
        delItem(item) {
            confirm('删除', '您确定要删除该帐号吗？', () => {
                this.delAccount(item.id)
            }, '确定', true)
        },
        async delAccount(id) {
            let _data = await delAccount(id);
            if (_data.status == 200) {
                this.$message.success('删除成功')
                this.list()
            } else {
                this.$message.error(_data.msg)
            }
        },
    },
    watch: {},
    filters: {}
}
</script>

<style lang="scss" scoped>
.red {
    color: #f61919;
}

.orgDetail {
    width: 100%;
    min-height: calc(100vh - (173px + 159px));
    background: #f3f5f7;
    padding: 20px;
    display: flex;
    justify-content: flex-start;

    .title {
        display: flex;
        justify-content: flex-start;
        align-items: center;
        padding-bottom: 25px;
        border-bottom: 1px solid #e3e7f0;

        b {
            font-size: 22px;
            color: #16181d;
            font-weight: bold;
            margin-left: 10px;
        }

        .icon-box {
            width: 30px;
            height: 30px;
            background-image: linear-gradient(-30deg,
                #3579fb 0%,
                #44a3ff 100%);
            box-shadow: 0px 10px 10px 0px rgba(50, 150, 255, 0.3);
            border-radius: 10px;
            text-align: center;
            line-height: 30px;

            i {
                font-size: 20px;
                color: #ffffff;
            }
        }
    }
}

.right-box {
    flex: 1;
    margin-left: 25px;
    width: 100%;
    height: 100%;
    min-height: calc(100vh - (173px + 159px));
    background: #f3f5f7;

    .table-box {
        width: 100%;
        background-image: linear-gradient(0deg,
            #ffffff 84%,
            #edf6ff 100%);
        padding: 30px 20px 0;
        border-radius: 10px;
        min-height: 500px;

        .tab {
            width: 100%;
            display: flex;
            justify-content: flex-start;
            align-items: center;
            border-bottom: solid 2px #e3e7f0;

            span {
                width: max-content;
                margin-left: 45px;
                height: 60px;
                line-height: 60px;
                font-size: 18px;
                color: #63686e;
                margin-right: 20px;
                cursor: pointer;

                &.active {
                    color: #2791ff;
                    font-weight: bold;
                    border-radius: 2px;
                    border-bottom: solid 4px #2791ff;
                }
            }
        }


        .list {
            width: 100%;

            .btn {
                width: 60px;
                height: 26px;
                border-radius: 4px;
                font-size: 14px;
                text-align: center;
                line-height: 26px;
                margin: 0 auto;

                &.gray {
                    color: #8a8a8a;
                    background-color: #f2f2f2;
                }

                &.yellow {
                    color: #fad471;
                    background-color: #fffbdd;
                }

                &.orange {
                    color: #f58739;
                    background-color: #ffeedd;
                }

                &.red {
                    color: #f8001a;
                    background-color: #ffdddd;
                }
            }
        }

        .search-flex {
            width: 100%;
            display: flex;
            justify-content: space-between;
            align-items: center;

            padding: 20px 0;

            .shensu {
                min-width: 113px;
                height: 37px;
                background-image: linear-gradient(0deg,
                    #f59a23 0%,
                    #feb555 100%);
                border-radius: 4px;
                padding: 0 20px;
                text-align: center;
                line-height: 37px;
                font-size: 16px;
                color: #ffffff;
                cursor: pointer;

                i {
                    font-size: 20px;
                    margin-right: 5px;
                    color: #ffffff;
                }
            }

            .search-box {
                display: flex;
                justify-content: flex-start;
                align-items: center;

                .search-btn {
                    width: 112px;
                    height: 36px;
                    background-image: linear-gradient(0deg,
                        #2791ff 0%,
                        #81b6ff 100%);
                    border-radius: 4px;
                    text-align: center;
                    line-height: 36px;
                    font-size: 16px;
                    color: #ffffff;
                    margin-left: 15px;
                    cursor: pointer;

                    i {
                        font-size: 20px;
                        margin-right: 5px;
                        color: #ffffff;
                    }

                    &.reset {
                        background-image: none;
                        background-color: #ffffff;
                        border-radius: 4px;
                        border: solid 1px #cccccc;
                        line-height: 34px;
                        color: #333333;

                        i {
                            color: #999999;
                        }
                    }
                }
            }

        }
    }
}
</style>


